import * as yup from "yup"

import { cnicValidation, numValidation, numValidationGreater, stringValidationYup } from "helpers/validations"

import dayjs from "dayjs"
import { regex } from "constants/regex"
import { t } from "i18next"

const getSalesValidationSchema = platform =>
  yup.object().shape({
    project: yup.object().required(t("Project Name is required")).nullable(),
    unit: yup.object().required(t("Unit is required")).nullable(),
    nationalId: numValidation(t("National ID is required")).nullable(),
    nationality: yup.object().required(t("Nationality is required")).nullable(),
    country: yup.object().required(t("Country is required")).nullable(),
    city: yup.object().required(t("City is required")).nullable(),
    amount: numValidation(t("Amount is required")).nullable(),
    receiptNumber: stringValidationYup(null, regex.alphaNumeric()).nullable(),
    modeOfPayment: yup.string().required(t("Mode of payment is required")).nullable(),
    paymentProof: yup.array().of(yup.object().shape({ file: yup.mixed() })),
    comment: stringValidationYup(),
    discountType: yup.string().required(t("Discount type is required")).nullable(),
    referenceNumber: stringValidationYup(
      platform === "bayut_ksa" ? null : t("Reference number is required"),
      regex.ksaFinanceRegex
    ).nullable(),
    depositDate: yup.date().required(t("Deposit date is required")).nullable(),
    chequeDate: yup.date().required(t("Cheque date is required")).nullable(),
    bank: yup.string().required(t("Bank is required")).nullable(),
    depositBank: yup.string().required(t("Bank is required")).nullable(),
    chequeBank: yup.string().required(t("Bank is required")).nullable(),
    payorderBank: yup.string().required(t("Bank is required")).nullable(),
    paymentType: yup.object().required(t("Payment type is required")).nullable(),
    cdpCommitment: numValidation(t("CDP commitment is required")).nullable(),
    dateOfBirth: yup.mixed().test("DOB", t("Age must be greater than or equal to 18 years old"), value => {
      if (!value) return true // allow empty, validation elsewhere
      const dob = dayjs(value)
      const eighteenthBirthday = dob.add(18, "years")
      return dayjs().isSameOrAfter(eighteenthBirthday, "day")
    }),

    beneficiaryAccountNumber:
      platform === "bayut_ksa"
        ? stringValidationYup(null, regex.ksaOnlinePaymentRegex).nullable()
        : stringValidationYup(t("Beneficiary account  number is required"), regex.alphaNumeric()).nullable(),
    beneficiaryAccountNumberPayorder:
      platform === "bayut_ksa"
        ? stringValidationYup(null, regex.ksaOnlinePaymentRegex).nullable()
        : stringValidationYup(t("Beneficiary account  number is required"), regex.alphaNumeric()).nullable(),
    payorderNumber: numValidation(t("Pay Order number is required")).nullable(),
    depositSlipNumber:
      platform === "bayut_ksa"
        ? stringValidationYup(null, regex.ksaFinanceRegex).nullable()
        : numValidation(t("Deposit Slip number is required")).nullable(),
    fromAccountTitle: stringValidationYup().nullable(),
    fromAccountNumber: stringValidationYup(null, regex.ksaOnlinePaymentRegex).nullable(),
    beneficiaryAccountTitle: stringValidationYup().nullable(),
    transactionDate: yup.date().nullable(),
    accountNumber: stringValidationYup(t("Account number is required"), regex.ksaOnlinePaymentRegex).nullable(),
    transactionNumber:
      platform === "bayut_ksa"
        ? stringValidationYup(t("Transaction number is required"), regex.ksaOnlinePaymentRegex).nullable()
        : stringValidationYup(t("Transaction number is required")).nullable(),
    transactionId: stringValidationYup(t("Transaction Id is required"), regex.alphaNumeric(false)),
    dateOfTransaction: yup.date().required(t("Transaction Date is requied")).nullable(),
    nextTask: yup.number().nullable(),
    deadLine: yup.object().nullable(),
    saleType: yup.string().required(t("Sale type is required")).nullable(),
    bookingPlatform: yup.object().nullable(),
    bankLoanSubType: yup.string().required(t("Bank loan sub type is required")).nullable(),
  })

export default getSalesValidationSchema
